var _rect, _rect2, _path, _path2, _circle, _rect3, _rect4, _path3, _path4, _circle2, _rect5, _rect6, _path5, _path6, _circle3, _rect7, _rect8, _path7, _path8, _circle4, _rect9, _rect10, _path9, _path10, _circle5, _rect11, _rect12, _path11, _path12, _circle6, _path13, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _rect13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollectiveCreativeArts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 151,
    viewBox: "0 0 264 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 83.9784,
    y: 57.9327,
    width: 58,
    height: 58,
    rx: 9.61539,
    transform: "rotate(4 83.9784 57.9327)",
    fill: "#312FCA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 83.9784,
    y: 57.9327,
    width: 58,
    height: 58,
    rx: 9.61539,
    transform: "rotate(4 83.9784 57.9327)",
    stroke: "#F3F0E5",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.11 92.5226L130.688 103.541C131.317 104.265 130.757 105.388 129.8 105.322L109.204 103.881C108.247 103.814 107.848 102.624 108.572 101.994L119.591 92.4164C120.039 92.0262 120.72 92.0737 121.11 92.5226Z",
    fill: "#FD6E3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.37 87.1733L119.945 102.789C120.574 103.513 120.014 104.637 119.057 104.57L89.8666 102.529C88.9095 102.462 88.5111 101.271 89.2352 100.642L104.851 87.0671C105.3 86.6769 105.98 86.7244 106.37 87.1733Z",
    fill: "#FD6E3B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 117.045,
    cy: 77.9805,
    r: 5.38462,
    transform: "rotate(4 117.045 77.9805)",
    fill: "#F6C630"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 170.83,
    y: 44.8706,
    width: 50,
    height: 50,
    rx: 8.38461,
    transform: "rotate(8 170.83 44.8706)",
    fill: "#312FCA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 170.83,
    y: 44.8706,
    width: 50,
    height: 50,
    rx: 8.38461,
    transform: "rotate(8 170.83 44.8706)",
    stroke: "#F3F0E5",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M200.632 76.8284L208.163 86.8222C208.658 87.479 208.112 88.4062 207.297 88.2918L189.773 85.8289C188.958 85.7144 188.689 84.6725 189.346 84.1776L199.34 76.6467C199.747 76.3399 200.325 76.4213 200.632 76.8284Z",
    fill: "#FD6E3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M188.349 71.3731L199.022 85.5371C199.517 86.1939 198.971 87.1212 198.157 87.0068L173.319 83.5161C172.505 83.4016 172.235 82.3597 172.892 81.8648L187.056 71.1914C187.463 70.8846 188.042 70.966 188.349 71.3731Z",
    fill: "#FD6E3B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.027,
    cy: 64.1503,
    r: 4.61538,
    transform: "rotate(8 198.027 64.1503)",
    fill: "#F6C630"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 126.933,
    y: 71.9784,
    width: 58,
    height: 58,
    rx: 9.61539,
    transform: "rotate(-4 126.933 71.9784)",
    fill: "#312FCA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 126.933,
    y: 71.9784,
    width: 58,
    height: 58,
    rx: 9.61539,
    transform: "rotate(-4 126.933 71.9784)",
    stroke: "#F3F0E5",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M168.517 101.064L179.535 110.642C180.259 111.271 179.861 112.462 178.904 112.529L158.308 113.969C157.35 114.036 156.79 112.912 157.42 112.188L166.998 101.17C167.388 100.721 168.068 100.674 168.517 101.064Z",
    fill: "#FD6E3B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M153.176 97.8186L168.792 111.393C169.516 112.023 169.117 113.213 168.16 113.28L138.97 115.322C138.013 115.388 137.452 114.265 138.082 113.541L151.656 97.9249C152.047 97.476 152.727 97.4284 153.176 97.8186Z",
    fill: "#FD6E3B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 162.468,
    cy: 87.2293,
    r: 5.38462,
    transform: "rotate(-4 162.468 87.2293)",
    fill: "#F6C630"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 83.949,
    y: 3.98437,
    width: 58,
    height: 58,
    rx: 9.61539,
    transform: "rotate(-3 83.949 3.98437)",
    fill: "#312FCA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 83.949,
    y: 3.98437,
    width: 58,
    height: 58,
    rx: 9.61539,
    transform: "rotate(-3 83.949 3.98437)",
    stroke: "#F3F0E5",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.019 33.7915L135.868 43.5602C136.581 44.2022 136.162 45.3858 135.204 45.436L114.586 46.5165C113.628 46.5667 113.087 45.4335 113.729 44.7205L123.498 33.8712C123.896 33.4292 124.577 33.3935 125.019 33.7915Z",
    fill: "#FD6E3B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.738 30.2786L125.114 44.1237C125.827 44.7657 125.408 45.9493 124.45 45.9995L95.2284 47.5309C94.2702 47.5811 93.7297 46.4479 94.3717 45.7349L108.217 30.3583C108.615 29.9163 109.296 29.8807 109.738 30.2786Z",
    fill: "#FD6E3B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.212,
    cy: 19.8532,
    r: 5.38462,
    transform: "rotate(-3 119.212 19.8532)",
    fill: "#F6C630"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 55.6775,
    y: 31.8559,
    width: 50,
    height: 50,
    rx: 8.38461,
    transform: "rotate(9 55.6775 31.8559)",
    fill: "#312FCA"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 55.6775,
    y: 31.8559,
    width: 50,
    height: 50,
    rx: 8.38461,
    transform: "rotate(9 55.6775 31.8559)",
    stroke: "#F3F0E5",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9175 64.3284L92.2727 74.4521C92.7561 75.1174 92.1938 76.035 91.3816 75.9064L73.9026 73.138C73.0903 73.0093 72.8391 71.9629 73.5044 71.4795L83.6281 64.1242C84.0405 63.8246 84.6178 63.916 84.9175 64.3284Z",
    fill: "#FD6E3B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7315 58.66L83.1561 73.0081C83.6394 73.6734 83.0771 74.5911 82.2649 74.4624L57.4922 70.5388C56.68 70.4102 56.4287 69.3637 57.0941 68.8803L71.4422 58.4558C71.8546 58.1561 72.4319 58.2476 72.7315 58.66Z",
    fill: "#FD6E3B"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.5338,
    cy: 51.6077,
    r: 4.61538,
    transform: "rotate(9 82.5338 51.6077)",
    fill: "#F6C630"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 136.275,
    y: 17.9166,
    width: 50,
    height: 50,
    rx: 8.38461,
    transform: "rotate(5 136.275 17.9166)",
    fill: "#312FCA"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 136.275,
    y: 17.9166,
    width: 50,
    height: 50,
    rx: 8.38461,
    transform: "rotate(5 136.275 17.9166)",
    stroke: "#F3F0E5",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M167.709 48.271L175.753 57.8569C176.281 58.4869 175.784 59.4415 174.965 59.3698L157.335 57.8275C156.516 57.7558 156.193 56.7294 156.823 56.2008L166.409 48.1572C166.799 47.8295 167.381 47.8805 167.709 48.271Z",
    fill: "#FD6E3B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M155.157 43.4658L166.557 57.0518C167.085 57.6818 166.588 58.6364 165.769 58.5647L140.783 56.3787C139.964 56.307 139.64 55.2806 140.27 54.752L153.856 43.352C154.247 43.0243 154.829 43.0753 155.157 43.4658Z",
    fill: "#FD6E3B"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.443,
    cy: 35.7472,
    r: 4.61538,
    transform: "rotate(5 164.443 35.7472)",
    fill: "#F6C630"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61 93C61 91.8954 61.8954 91 63 91H83.2654C84.2607 91 85.1046 91.7319 85.2453 92.7172L88.7547 117.283C88.8954 118.268 89.7393 119 90.7346 119H191.265C192.261 119 193.105 118.268 193.245 117.283L196.755 92.7172C196.895 91.7319 197.739 91 198.735 91H219C220.105 91 221 91.8954 221 93V119V145C221 146.105 220.105 147 219 147H189H93H63C61.8954 147 61 146.105 61 145V119V93Z",
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 127.5,
    r: 1.5,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 45.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 259.5,
    cy: 38.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 11.5,
    r: 1.5,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.5,
    cy: 108.5,
    r: 1.5,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 179.5,
    cy: 8.5,
    r: 1.5,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 33 151)",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M212.5 23L236.5 14",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M232 72.5L250.5 74.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27 13L46 20.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 89L29.5 84.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveCreativeArts);
export default __webpack_public_path__ + "static/media/collective-creative-arts.620889ef544b4c630883a9ba371e1f0a.svg";
export { ForwardRef as ReactComponent };